import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Code, Smartphone, Check, ArrowRight } from 'lucide-react';
import { services } from '../mock';
import { SEO } from '../components/SEO';

const iconMap = {
  Globe: Globe,
  Code: Code,
  Smartphone: Smartphone
};

export const Services = () => {
  return (
    <div className="dark-container">
      <SEO 
        title="Our Services - Website Development & App Development in Bhubaneswar | NEXEN DIGITAL"
        description="Professional Website Development, App Development, and Software Development Services in Bhubaneswar. We offer custom web design, mobile app development, ecommerce solutions, and AI-powered development services in Odisha."
        keywords="website development services bhubaneswar, app development services bhubaneswar, custom web development, mobile app development services, ecommerce development, software development services, web design bhubaneswar, odisha"
      />
      {/* Hero Section */}
      <section style={{ padding: '100px 0 60px', textAlign: 'center' }}>
        <h1 className="display-huge" style={{ marginBottom: '24px', color: '#FFFFFF' }}>
          Our <span style={{ color: '#00FFD1' }}>Services</span>
        </h1>
        <p className="body-large" style={{ maxWidth: '800px', margin: '0 auto', color: 'rgba(255, 255, 255, 0.85)' }}>
          Comprehensive digital solutions powered by AI technology. From concept to deployment, we deliver excellence at every step.
        </p>
      </section>

      {/* Services Detail */}
      <section style={{ padding: '60px 0' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '60px' }}>
          {services.map((service, idx) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                style={{
                  display: 'grid',
                  gridTemplateColumns: idx % 2 === 0 ? '1fr 1fr' : '1fr 1fr',
                  gap: '60px',
                  alignItems: 'center',
                  background: '#121212',
                  padding: '60px',
                  border: '1px solid rgba(255, 255, 255, 0.25)'
                }}
              >
                {idx % 2 === 0 ? (
                  <>
                    <div>
                      <Icon size={64} style={{ color: '#00FFD1', marginBottom: '24px' }} />
                      <h2 className="display-medium" style={{ marginBottom: '20px', color: '#FFFFFF' }}>
                        {service.title}
                      </h2>
                      <p className="body-large" style={{ marginBottom: '32px', color: 'rgba(255, 255, 255, 0.85)' }}>
                        {service.description}
                      </p>
                      <Link to="/contact" className="btn-primary">
                        Get Started
                        <ArrowRight size={20} />
                      </Link>
                    </div>
                    <div>
                      <h3 className="heading-2" style={{ marginBottom: '24px', color: '#FFFFFF' }}>Key Features:</h3>
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {service.features.map((feature, fidx) => (
                          <li key={fidx} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <Check size={24} style={{ color: '#00FFD1', flexShrink: 0 }} />
                            <span className="body-large" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                              {feature}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      <h3 className="heading-2" style={{ marginBottom: '24px', color: '#FFFFFF' }}>Key Features:</h3>
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {service.features.map((feature, fidx) => (
                          <li key={fidx} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <Check size={24} style={{ color: '#00FFD1', flexShrink: 0 }} />
                            <span className="body-large" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                              {feature}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <Icon size={64} style={{ color: '#00FFD1', marginBottom: '24px' }} />
                      <h2 className="display-medium" style={{ marginBottom: '20px', color: '#FFFFFF' }}>
                        {service.title}
                      </h2>
                      <p className="body-large" style={{ marginBottom: '32px', color: 'rgba(255, 255, 255, 0.85)' }}>
                        {service.description}
                      </p>
                      <Link to="/contact" className="btn-primary">
                        Get Started
                        <ArrowRight size={20} />
                      </Link>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </section>

      {/* Process Section */}
      <section style={{ padding: '100px 0', background: '#121212' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <h2 className="display-large" style={{ textAlign: 'center', marginBottom: '60px', color: '#FFFFFF' }}>
            Our <span style={{ color: '#00FFD1' }}>Development Process</span>
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px' }}>
            {[
              { step: '01', title: 'Discovery', desc: 'Understanding your vision and requirements' },
              { step: '02', title: 'Design', desc: 'Creating intuitive and beautiful interfaces' },
              { step: '03', title: 'Development', desc: 'Building with AI-powered tools and technologies' },
              { step: '04', title: 'Testing', desc: 'Rigorous quality assurance and optimization' },
              { step: '05', title: 'Deployment', desc: 'Seamless launch and ongoing support' }
            ].map((item, idx) => (
              <div key={idx} style={{ background: '#000000', padding: '40px', border: '1px solid rgba(255, 255, 255, 0.25)', textAlign: 'center' }}>
                <div className="display-medium" style={{ color: '#00FFD1', marginBottom: '16px' }}>
                  {item.step}
                </div>
                <h3 className="heading-2" style={{ marginBottom: '12px', color: '#FFFFFF' }}>
                  {item.title}
                </h3>
                <p className="body-medium" style={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: '100px 0' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h2 className="display-large" style={{ marginBottom: '24px', color: '#FFFFFF' }}>
            Let's Build Your <span style={{ color: '#00FFD1' }}>Next Project</span>
          </h2>
          <p className="body-large" style={{ marginBottom: '40px', color: 'rgba(255, 255, 255, 0.85)' }}>
            Ready to transform your ideas into reality? Contact us today for a free consultation.
          </p>
          <Link to="/contact" className="btn-primary">
            Start Your Project
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};